import type { SVGProps } from "react";

export function HeartIcon({
	filled,
	...props
}: SVGProps<SVGSVGElement> & { filled?: boolean }) {
	if (filled) {
		return (
			// biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon; callers pass aria-hidden/aria-label via {...props}
			<svg
				width="18"
				height="17"
				viewBox="0 0 18 17"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					d="M16.513 8.58341L9.013 16.0114L1.513 8.58341C1.0183 8.10202 0.628639 7.52342 0.368544 6.88404C0.10845 6.24466 -0.016442 5.55836 0.00173387 4.86834C0.0199097 4.17832 0.180759 3.49954 0.474154 2.87474C0.767548 2.24994 1.18713 1.69266 1.70648 1.23799C2.22583 0.783313 2.8337 0.441096 3.49181 0.232888C4.14991 0.0246802 4.844 -0.0450088 5.53036 0.0282087C6.21673 0.101426 6.8805 0.315964 7.47987 0.658314C8.07925 1.00066 8.60124 1.46341 9.013 2.01741C9.42653 1.46743 9.94913 1.00873 10.5481 0.670012C11.1471 0.331296 11.8095 0.119857 12.4939 0.0489273C13.1784 -0.0220022 13.8701 0.0491053 14.5258 0.257799C15.1815 0.466493 15.787 0.80828 16.3045 1.26177C16.8221 1.71526 17.2404 2.27069 17.5334 2.8933C17.8264 3.51591 17.9877 4.19229 18.0073 4.88012C18.0269 5.56794 17.9043 6.2524 17.6471 6.89066C17.39 7.52891 17.0039 8.10723 16.513 8.58941"
					fill="#2F322F"
				/>
			</svg>
		);
	}

	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon; callers pass aria-hidden/aria-label via {...props}
		<svg
			width="20"
			height="19"
			viewBox="0 0 20 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.513 9.58341L10.013 17.0114L2.513 9.58341C2.0183 9.10202 1.62864 8.52342 1.36854 7.88404C1.10845 7.24466 0.983558 6.55836 1.00173 5.86834C1.01991 5.17832 1.18076 4.49954 1.47415 3.87474C1.76755 3.24994 2.18713 2.69266 2.70648 2.23799C3.22583 1.78331 3.8337 1.4411 4.49181 1.23289C5.14991 1.02468 5.844 0.954991 6.53036 1.02821C7.21673 1.10143 7.8805 1.31596 8.47987 1.65831C9.07925 2.00066 9.60124 2.46341 10.013 3.01741C10.4265 2.46743 10.9491 2.00873 11.5481 1.67001C12.1471 1.3313 12.8095 1.11986 13.4939 1.04893C14.1784 0.977998 14.8701 1.04911 15.5258 1.2578C16.1815 1.46649 16.787 1.80828 17.3045 2.26177C17.8221 2.71526 18.2404 3.27069 18.5334 3.8933C18.8264 4.51591 18.9877 5.19229 19.0073 5.88012C19.0269 6.56794 18.9043 7.2524 18.6471 7.89066C18.39 8.52891 18.0039 9.10723 17.513 9.58941"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
